import { useEffect, useState } from "react";
import { useLocationConfigContext } from "../context/LocationConfigContext";

/**
 * Selección inicial del filtro de establecimientos de las pestañas de Locaciones.
 * Arranca solo con el establecimiento preferido del usuario (Mi perfil o puesto de atención abierto),
 * si está en la lista; si no, con todos. Espera a conocerlo para no fijar "todos" antes de tiempo.
 */
export default function useEstablishmentFilterSelection(enabled: boolean) {
    const { establishments, preferredBuildingId } = useLocationConfigContext();
    const [selectedEstablishmentIds, setSelectedEstablishmentIds] = useState<number[]>([]);
    const [isFilterInitialized, setIsFilterInitialized] = useState(false);

    useEffect(() => {
        if (!enabled || isFilterInitialized) return;
        if (preferredBuildingId === undefined) return;
        const allIds = (establishments ?? []).map((est) => est.buildingid);
        if (allIds.length === 0) return;
        const startWithPreferred = preferredBuildingId != null && allIds.includes(preferredBuildingId);
        setSelectedEstablishmentIds(startWithPreferred ? [preferredBuildingId] : allIds);
        setIsFilterInitialized(true);
    }, [enabled, isFilterInitialized, establishments, preferredBuildingId]);

    return { selectedEstablishmentIds, setSelectedEstablishmentIds };
}
